export default {"src":"/_next/static/media/Warning.1e2d4fc9.svg","height":17,"width":17};